import React from 'react';
import { useTranslation } from 'react-i18next';

const CookiePolicyPage = () => {
  const { t } = useTranslation();

  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
      <h1 className="cookie-policy-h1">{t('cookiePolicy.title')}</h1>
      <div className="cookie-policy-date-container">
        <p>{t('cookiePolicy.effectiveDate')}</p>
        <p>{t('cookiePolicy.lastUpdated')}</p>
      </div>
      &nbsp;
      <h2>{t('cookiePolicy.whatAreCookies.title')}</h2>
      <div className="cookie-policy-p">
        <p>{t('cookiePolicy.whatAreCookies.p1')}</p>
        <p>{t('cookiePolicy.whatAreCookies.p2')}</p>
      </div>
      &nbsp;
      <h2>{t('cookiePolicy.howWeUseCookies.title')}</h2>
      <div className="cookie-policy-p">
        <p>{t('cookiePolicy.howWeUseCookies.p1')}</p>
        <p>{t('cookiePolicy.howWeUseCookies.p2')}</p>
      </div>
      &nbsp;
      <h2>{t('cookiePolicy.typesOfCookies.title')}</h2>
      <div className="cky-audit-table-element"></div>
      &nbsp;
      <h2 style={{ marginBottom: '20px' }}>{t('cookiePolicy.managePreferences.title')}</h2>
      <a className="cky-banner-element">{t('cookiePolicy.managePreferences.consentLink')}</a>
      <br />
      <div>
        <p>{t('cookiePolicy.managePreferences.p1')}</p>
        <p>{t('cookiePolicy.managePreferences.p2')}</p>
        <p>Chrome: <a target="_blank" rel="noopener noreferrer" href="https://support.google.com/accounts/answer/32050">https://support.google.com/accounts/answer/32050</a></p>
        <p>Safari: <a target="_blank" rel="noopener noreferrer" href="https://support.apple.com/en-in/guide/safari/sfri11471/mac">https://support.apple.com/en-in/guide/safari/sfri11471/mac</a></p>
        <p>Firefox: <a target="_blank" rel="noopener noreferrer" href="https://support.mozilla.org/en-US/kb/clear-cookies-and-site-data-firefox?redirectslug=delete-cookies-remove-info-websites-stored&redirectlocale=en-US">https://support.mozilla.org/en-US/kb/clear-cookies-and-site-data-firefox?redirectslug=delete-cookies-remove-info-websites-stored&redirectlocale=en-US</a></p>
        <p>Internet Explorer: <a target="_blank" rel="noopener noreferrer" href="https://support.microsoft.com/en-us/topic/how-to-delete-cookie-files-in-internet-explorer-bca9446f-d873-78de-77ba-d42645fa52fc">https://support.microsoft.com/en-us/topic/how-to-delete-cookie-files-in-internet-explorer-bca9446f-d873-78de-77ba-d42645fa52fc</a></p>
        <p>{t('cookiePolicy.managePreferences.p3')}</p>
      </div>
    </div>
  );
};

export default CookiePolicyPage;